import styled from 'styled-components';
import FleetSidebar from './component';

export default styled(FleetSidebar)`
  background-color: var(--grey800);
  height: 100%;
  flex: 0 0 auto;

  transition: width 0.3s;
  width: 215px;

  &.collapsed {
    width: 56px;
    transition: width 0.3s;
  }
`;
